(ns io.daskul.webapp.widgets.fsm.badge
  "Icon utilities for FSM state badges.
   Badge rendering is handled by display/value-badge."
  (:require
   [uix.core :refer [$]]
   [io.daskul.webapp.ui.icons :as icons]))

;; ============================================================================
;; Icon Mapping
;; ============================================================================

(def icon-name->component
  "Maps icon name strings to Tabler icon components."
  {"check"        icons/icon-check
   "check-circle" icons/icon-circle-check
   "pencil"       icons/icon-pencil
   "archive"      icons/icon-archive
   "globe"        icons/icon-globe
   "calendar"     icons/icon-calendar
   "clock"        icons/icon-clock
   "trash"        icons/icon-trash
   "x"            icons/icon-x
   "alert"        icons/icon-alert-circle
   "play"         icons/icon-player-play
   "send"         icons/icon-send
   "x-circle"     icons/icon-circle-x
   "refresh"      icons/icon-refresh
   "receipt"      icons/icon-receipt
   "dot"          icons/icon-point-filled})

(defn get-icon
  "Get icon component for icon name string. Optional color for icon tint."
  ([icon-name size]
   (get-icon icon-name size nil))
  ([icon-name size color]
   (when-let [icon-component (get icon-name->component icon-name)]
     ($ icon-component (cond-> {:size (or size 14)}
                         color (assoc :color color))))))
